var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "row header d-flex align-items-center justify-content-between",
      class: _vm.headerClass,
    },
    [
      _vm.title
        ? _c("div", { staticClass: "col col-sm order-1 pr-0" }, [
            _c("h1", { staticClass: "content-title" }, [
              _vm._v(_vm._s(_vm.$t(_vm.title))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showSearch
        ? _c(
            "div",
            {
              staticClass:
                "col-12 col-sm text-center order-3 order-sm-2 pt-2 pt-sm-0 search-box",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "form-group has-search autocomplete mb-0 flex-nowrap input-group",
                },
                [
                  _c("span", {
                    staticClass: "fa form-control-feedback",
                    class: [_vm.isLoading ? "fa-spinner" : "fa-search"],
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "autocomplete-input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.valueSearch,
                          expression: "valueSearch",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass:
                        "form-control form-control-sm form-control-search",
                      attrs: {
                        type: "search",
                        placeholder: _vm.$t(_vm.placeholderSearch),
                      },
                      domProps: { value: _vm.valueSearch },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.valueSearch = $event.target.value.trim()
                          },
                          _vm.handleModelInput,
                        ],
                        keyup: _vm.onKeyUp,
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.valueSearch
                    ? _c(
                        "div",
                        { staticClass: "input-group-append position-relative" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-default text-right min-w-auto px-2 py-0 d-flex align-items-center justify-content-center",
                              attrs: { type: "button" },
                              on: { click: _vm.clearSearchValue },
                            },
                            [_vm._m(0)]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canConfig || _vm.canAdd || _vm.hasButtonsRightSlot
        ? _c(
            "div",
            {
              staticClass:
                "col col-sm order-2 order-sm-3 pl-0 d-flex justify-content-end",
            },
            [
              _vm.canConfig
                ? _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-main btn-rounded btn-sm my-0 min-w-auto",
                      class: [_vm.canAdd ? "pr-3" : ""],
                      attrs: {
                        "data-toggle": "tooltip-city",
                        title: _vm.$t(_vm.configTitle),
                        to: { name: _vm.routeConfigName },
                      },
                    },
                    [_c("i", { staticClass: "fas fa-cogs" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canAdd
                ? _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-main btn-rounded btn-sm min-w-auto my-0 mx-0 order-3 d-flex flex-row align-items-center justify-content-center flex-nowrap d-sm-inline",
                      attrs: {
                        "data-toggle": "tooltip-city",
                        title:
                          _vm.showAddTitle && _vm.addTitle
                            ? null
                            : _vm.$t(_vm.addTitle),
                        to: {
                          name: _vm.routeAddName,
                          params: _vm.routeAddParams,
                        },
                      },
                    },
                    [
                      _vm.icon != "" ? _c("i", { class: _vm.icon }) : _vm._e(),
                      _vm._v(" "),
                      _vm.showAddTitle
                        ? [
                            _vm._v("\n                 "),
                            _c("span", [_vm._v(_vm._s(_vm.$t(_vm.addTitle)))]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("buttons-right"),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "d-flex align-items-center justify-content-center" },
      [
        _c("i", {
          staticClass: "fas fa-times-circle",
          staticStyle: { "font-size": "1.1rem" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }